import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LucideAngularModule } from 'lucide-angular';
import { SpinnerComponent } from '../../../components/spinner/spinner.component';
import { Icons } from '../../../../shared/helpers/icons';
import { IContact } from '../../../../shared/models/contact';
import { UserDataService } from '../../../../shared/services/userData.service';
import { ContactsService } from '../../../../shared/services/contact.service';
import { BasicResourcesService } from '../../../../shared/services/basicResource.service';

@Component({
  selector: 'new-resource',
  standalone: true,
  imports: [
    CommonModule,
    LucideAngularModule,
    FormsModule,
    SpinnerComponent
  ],
  templateUrl: './new-resource.component.html',
  styleUrl: './new-resource.component.css'
})
export class NewResourceComponent implements OnInit {
  icons = Icons;
  currentBuildingId: string | null = null;
  fullContactsList: IContact[] = [];
  contactsList: IContact[] = [];

  @Output() onClose = new EventEmitter<void>();
  @Output() onSave = new EventEmitter<any>();

  resource = {
    resources: '',
    contact_id: 0,
    location: '',
    resource_group: 'Tools'
  };

  suggestions: string[] = [
    'Local Emergency Management Agency',
    'Local Hospital',
    'Local School (Nurse)',
    'Mental Health',
    'Public Health',
    'Local School'
  ];

  loading: boolean = false;
  showSuggestions: boolean = false;

  constructor(
    private userDataService: UserDataService,
    private contactsService: ContactsService,
    private basicResourcesService: BasicResourcesService
  ) {}

  ngOnInit(): void {
    this.currentBuildingId = this.userDataService.getBuildingId();
    this.loadContacts();
  }

  loadContacts(): void {
    this.loading = true;
    this.contactsService.getContacts(this.currentBuildingId!).subscribe({
      next: (response) => {
        this.loading = false;
        this.fullContactsList = response.data || [];
        this.contactsList = [...this.fullContactsList];

        if (this.contactsList.length > 0) {
          this.contactsList.sort((a, b) => a.name.localeCompare(b.name));
          // ✅ Default to first contact
          this.resource.contact_id = this.contactsList[0].id;
        }
      },
      error: (error: any) => {
        this.loading = false;
        console.error('Error loading contacts:', error.message);
      }
    });
  }

  get filteredSuggestions(): string[] {
    const query = this.resource.location?.toLowerCase() || '';
    return this.suggestions.filter(s => s.toLowerCase().includes(query));
  }

  selectSuggestion(value: string): void {
    this.resource.location = value;
    this.showSuggestions = false;
  }

  hideSuggestions(): void {
    setTimeout(() => this.showSuggestions = false, 150);
  }

  closeModal(): void {
    this.onClose.emit();
  }

  saveNew(): void {
    if (this.resource.location && this.resource.resources && this.currentBuildingId) {
      this.loading = true;
      console.log("Submitting resource:", this.resource);
      this.basicResourcesService.createBasicResource(this.currentBuildingId, this.resource).subscribe({
        next: (res) => {
          this.loading = false;
          if (!res.has_error) {
            this.onSave.emit({ type: 'success', message: 'This occurred after creating new resource.' });
          }
        },
        error: (err) => {
          this.loading = false;
          this.onSave.emit({ type: 'unsuccess', message: err.message });
        }
      })
    }
  }

}
